<template>
  <div>
   

  <widget-articles :articles="articles"></widget-articles>


  </div>
</template>

<script>
  import '../assets/scss/_toolbox_fonts.scss'
  import '../assets/scss/_toolbox_margin_padding.scss'
  import '../assets/scss/_toolbox_layout.scss'
  
  import Nav from './Nav.vue'
  import Hero from './Hero.vue'
  import Footer from './Footer.vue'
  import Subhero from './Subhero.vue'
  import WidgetAuthor from './WidgetAuthor.vue'
  import WidgetFeaturedBlock from './WidgetFeaturedBlock.vue'
  import WidgetIllustrations from './WidgetIllustrations.vue'
  import WidgetFeaturedOn from './WidgetFeaturedOn.vue'
  import WidgetProviders from './WidgetProviders.vue'
  import WidgetFaq from './WidgetFaq.vue'
  import WidgetArticlesRelated from './WidgetArticlesRelated.vue'
  export default {
    data() {
      return {
        herotype :'home',
        urlBackground :'',
        providers : [
          {logo: 'public/review_ria.png',url:'ria.com',score:'5.8'},
          {logo: 'public/review_worldremit.png',url:'paypal.com',score:'8.3'},
          {logo: 'public/review_paypal.png',url:'paypal.com',score:'5.1'},
          {logo: 'public/review_remitly.png',url:'paypal.com',score:'7.6'},
          {logo: 'public/review_transfergo.png',url:'paypal.com',score:'8.2'},
          {logo: 'public/review_western.png',url:'paypal.com',score:'7.9'},
          {logo: 'public/review_transferwise.png',url:'paypal.com',score:'8.8'},
          {logo: 'public/review_xendpay.png',url:'paypal.com',score:'6.6'},
          {logo: 'public/review_skrill.png',url:'paypal.com',score:'8.3'}
        ],
        articles : [
          { cover: 'https://images.prismic.io/monito/dd9100c21fa169148f105678a8ba45047025dce4_keyboard-typing-sending-money-online.jpg',
            url:'https://www.monito.com/en/wiki/what-is-the-cheapest-way-to-send-money-abroad',
            title:'Find the Cheapest Way to Send Money Abroad',
            date_author:'Apr. 15, 2019  -  by François Briod'},

            { cover: 'https://images.prismic.io/monito/b8d2f5539c4cbf71088d90a7985ba1d37ffade26_artem-bali-659437-unsplash-5.jpg',
            url:'https://www.monito.com/en/wiki/zelle-international-money-transfer-alternatives',
            title:'Can I use Zelle to send money Internationally? No! Find alternatives now',
            date_author:'Mar. 28, 2019  -  by François Briod'},

          { cover: 'https://images.prismic.io/monito/prismic/d2d5b77ee0ed5cbc9494376cdd1ad510409469c7_cheetah-running-hero.jpg',
            url:'https://www.monito.com/en/wiki/what-is-the-fastest-way-to-send-money-abroad',
            title:'Find the Fastest Way to Send Money Abroad',
            date_author:'Nov. 14, 2019'},
          
          

          { cover: '',
            url:'https://www.monito.com/en/wiki/square-cash-international-money-transfer-alternatives',
            title:'Can I use Square Cash to send money Internationally?',
            date_author:'Oct. 01, 2019'},
          
          { cover: 'https://images.prismic.io/monito/eaee3cd7169be1fe0363a708de2e97fa4622501c_best-international-bank-accounts-for-digital-nomads-laptop-money.jpg',
            url:'https://www.monito.com/en/wiki/what-is-the-fastest-way-to-send-money-abroad',
            title:'The best international bank accounts for digital nomads, travelers & expats',
            date_author:'Nov. 14, 2018  -  by Caroline Sieg'}
          
         

        ]
      }
    },
    methods : {
      handleScroll(event){
      // hauteur de la zone de scroll
      //this.scroll_zone = this.$refs.scroll_zone.clientHeight;
      var bodyRect = document.body.getBoundingClientRect(),
      container_width = this.$refs.main.clientWidth,
      aside = this.$refs.scroll_widgets.getBoundingClientRect(),
      scroll_zone = this.$refs.scroll_zone.getBoundingClientRect(),
      left = scroll_zone.right,

      aside_width = this.$refs.scroll_widgets.clientWidth,
      scroll_zone_width = this.$refs.scroll_zone.clientWidth,
      aside_height = this.$refs.scroll_widgets.clientHeight,
      scroll_zone_height = this.$refs.main.clientHeight,


      
      // position top de la zone de scroll
      offset_scroll_zone = scroll_zone.top - bodyRect.top;
      var position_x_aside = scroll_zone.top - bodyRect.top;

      var bottom_main_content = (offset_scroll_zone + scroll_zone_height);


      // valeur du scoll de la page
      var y = window.scrollY;
      var debut_scroll = 0;

   
        if(y > (position_x_aside - 20)){
          if(y <= (bottom_main_content - aside_height - 20)){
            this.$refs.scroll_widgets.style.position = 'fixed';
            this.$refs.scroll_widgets.style.left = left+(container_width - (scroll_zone_width + aside_width)) + 'px';
            this.$refs.scroll_widgets.style.top = 20 + 'px';
          } else {
            this.$refs.scroll_widgets.style.top = ((scroll_zone_height - aside_height)) + 'px';
            this.$refs.scroll_widgets.style.position = 'absolute';
            this.$refs.scroll_widgets.style.left = '';
          }
        } else {
          this.$refs.scroll_widgets.style.top = '0px';
          this.$refs.scroll_widgets.style.position = 'absolute';
          this.$refs.scroll_widgets.style.left = '';
        }
  
      }
    },  
    components: {
      'app-navigation' : Nav,
      'app-hero-section' : Hero,
      'app-subhero-section' : Subhero,
      'widget-text-featured-block' : WidgetFeaturedBlock,
      'widget-featured-on' : WidgetFeaturedOn,
      'widget-providers' : WidgetProviders,
      'widget-articles' : WidgetArticlesRelated,
      'app-footer' : Footer,
      'widget-faq' : WidgetFaq,
      'widget-author' : WidgetAuthor,
      'widget-illustrations' : WidgetIllustrations
    },
    created() {
      window.addEventListener('scroll', this.handleScroll);
      window.addEventListener('resize', this.handleScroll);
    }
  }
</script>

<style lang="scss">
  body {
    position: relative;
    background : #F8F8F8;
    font-family:Avenir Next,-apple-system,system-ui,Segoe UI,Roboto,Ubuntu,Cantarell,Noto Sans,sans-serif,BlinkMacSystemFont,Helvetica Neue,Arial;
    box-sizing: border-box;
    color: #353C45;
    max-width: 100vw;
    margin: 0;
}

  main {
    position: relative;
    z-index: 10000;
  }

  .scroller {
    width: 352px;
    box-sizing: border-box;
    position: absolute;
    right: 0;
    top: 0;
  }

  @media ($tablet_portrait) {
    body {
      width: 100%;
      overflow: scrollY;
    }
    main {
      width: 100%;
      h1 {
        text-align: center;
      }
    }
    .scroller {
      display: none;
    }
  }

</style>


// WEBPACK FOOTER //
// src/components/RelatedContent.vue